exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1JCjHiFg2NIKYU{margin:0 auto;max-width:1250px}._1jW8uH3m1m7kd2{display:flex;flex-direction:column}._1gPa0O1LM6CQmM{box-sizing:border-box;position:relative;will-change:max-height}._1gPa0O1LM6CQmM+._1gPa0O1LM6CQmM{padding-top:16px}._2QsPdzOagwwvNr{margin-top:-24px}", ""]);

// exports
exports.locals = {
	"upNextCards": "_1JCjHiFg2NIKYU",
	"upNextCardList": "_1jW8uH3m1m7kd2",
	"upNextCardListItem": "_1gPa0O1LM6CQmM",
	"homeNoUpNextCards": "_2QsPdzOagwwvNr"
};